module.exports = __webpack_public_path__ + "img/section2_pic1.d0d07a2b.png";